import { useQuery } from 'react-query'
import queryKeys from '../../../constants/queryKeys'
import { apiGetOptions } from '../../../services/loginService'

export default () =>
  useQuery(queryKeys.loginOptions, apiGetOptions, {
    retry: 3,
  })
